import { render, staticRenderFns } from "./PackageLabelTemplate.vue?vue&type=template&id=453a3edb&scoped=true&lang=pug"
import script from "./PackageLabelTemplate.vue?vue&type=script&lang=js"
export * from "./PackageLabelTemplate.vue?vue&type=script&lang=js"
import style0 from "./PackageLabelTemplate.vue?vue&type=style&index=0&id=453a3edb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a3edb",
  null
  
)

export default component.exports